export const PREVIEW_MOCK_UINFIN = 'S1234567A'
